import { useQuery } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import type { OnRampPricePerUnitParams } from '../transferTypes'

export const useGetOnRampPricePerUnit = (payload: OnRampPricePerUnitParams) =>
  useQuery({
    queryKey: ['ON_RAMP_PRICE_PER_UNIT', payload],
    queryFn: () => transferServices.getOnRampPricePerUnit(payload),
    staleTime: 60 * 1000,
    enabled: !!payload.crypto, // Enable for all currencies including XAUT
    retry: false, // Don't retry on 404
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
